import Box from 'components/shared/Box'
import loaderImg from 'assets/icons/loader-orange.svg'
import Loader from 'components/shared/Loader'
import { ResponsiveSize } from 'styles/types'
import styled from 'styled-components'
import { fadeInOnRender } from 'styles/animations'

interface SpaLoaderProps {
    height?: ResponsiveSize
}

export const StyledSpaLoader = styled(Box)`
    ${fadeInOnRender};
`
// TODO: unify all loaders (std/spa/calendar), combine into one
const SpaLoader = ({ height }: SpaLoaderProps) => (
    <StyledSpaLoader
        align="center"
        justify="center"
        height={height}
        isFullWidth
    >
        <Loader src={loaderImg} size={[24, 40]} />
    </StyledSpaLoader>
)

export default SpaLoader
